import { AppSelectBox } from 'components';
import useESTList from 'hooks/API/GET/useESTList';
import { Fragment } from 'react';

function ESTDropDown({ enableAPI, value, handleChange, fieldErrors = {} }) {
  const queryParams = `?mode=dropdown`;
  const { data, isLoading, isError } = useESTList({ enabled: enableAPI, queryParams });

  return (
    <AppSelectBox
      labelProps={{ label: 'Select curriculum' }}
      selectProps={{
        value,
        onChange: handleChange,
      }}
      fieldErrors={fieldErrors}
    >
      {isLoading ? (
        <option disabled value="">
          Loading...
        </option>
      ) : isError ? (
        <option disabled value="">
          Failed to load list
        </option>
      ) : (
        <Fragment>
          {data?.data?.length > 0 ? (
            <Fragment>
              <option value="">Choose</option>
              {data?.data?.map((option) => {
                return (
                  <option key={option._id} value={option._id}>
                    {option.name}
                  </option>
                );
              })}
            </Fragment>
          ) : (
            <option value="">No options found</option>
          )}
        </Fragment>
      )}
    </AppSelectBox>
  );
}

ESTDropDown.defaultProps = {
  handleChange: () => {},
};

export default ESTDropDown;
